import { c as _c } from "react/compiler-runtime";
// The one error display: one short line, status red, role=alert. Inline (`inline`) inside a sentence or a row.
// Styles: book.css `.error-line`.
import type { ReactNode } from "react";
export function ErrorLine(t0) {
  const $ = _c(7);
  const {
    children,
    inline,
    className
  } = t0;
  const t1 = inline && "inline";
  let t2;
  if ($[0] !== className || $[1] !== t1) {
    t2 = ["error-line", t1, className].filter(Boolean);
    $[0] = className;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const cls = t2.join(" ");
  let t3;
  if ($[3] !== children || $[4] !== cls || $[5] !== inline) {
    t3 = inline ? <span role="alert" className={cls}>{children}</span> : <div role="alert" className={cls}>{children}</div>;
    $[3] = children;
    $[4] = cls;
    $[5] = inline;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}